<app-lfsa-card *ngIf="!mostrarFormulario" [innTemplate]="enviarTemplate" [titulo]="'Parametros Cobros Autoservicios'">
</app-lfsa-card>

<ng-template #enviarTemplate>
  <div class="container">
    <div class="row">
      <div class="col-sm-9">
        <input #quickFilter (keyup)="onQuickFilterChanged()" [(ngModel)]="textoBuscar" class="form-control float-left "
               id="quickFilter " placeholder="Buscar.. "/>
      </div>
      <div class="col-sm-3">
        <button (click)="abrirFormularioParaGuardarHTML()" class="float-right btn btn-outline-success btn btn-block">
          Agregar Parametro
        </button>
      </div>
    </div>
    <div class="row">
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [columnDefs]="columnDefs"
                       [frameworkComponents]="frameworkComponents" [ngStyle]="cobroAutoModulo.agGrid.style"
                       [paginationPageSize]="cobroAutoModulo.agGrid.paginacion" [pagination]="true" [rowData]="rowData"
                       [rowSelection]="rowSelection" class="{{cobroAutoModulo.agGrid.class}}"
                       id="{{cobroAutoModulo.agGrid.id}}">
      </ag-grid-angular>
    </div>
  </div>
</ng-template>

<!-- <div class="row col-md-12 animated fadeInRight" *ngIf="!mostrarFormulario">
  <h2 class="container float-left">
    Parametros Cobros Autoservicios
  </h2>
  <hr />
  <div class="container">
    <div class="row">
      <div class="col-sm-9">
        <input class="form-control float-left " placeholder="Buscar.. " [(ngModel)]="textoBuscar" id="quickFilter "
          (keyup)="onQuickFilterChanged()" #quickFilter />
      </div>
      <div class="col-sm-3">
        <button (click)="abrirFormularioParaGuardarHTML()" class="float-right btn btn-outline-success btn btn-block">
          Agregar Parametro
        </button>
      </div>
    </div>
  </div>
  <ag-grid-angular
  class="{{cobroAutoModulo.agGrid.class}}" #agGrid
  [ngStyle] = "cobroAutoModulo.agGrid.style"
  id="{{cobroAutoModulo.agGrid.id}}"
  paginationPageSize ="{{cobroAutoModulo.agGrid.paginacion}}"
  [pagination]="true"

  [frameworkComponents]="frameworkComponents"
  [columnDefs]="columnDefs"
  [rowSelection]="rowSelection"
  [rowData]="rowData"
  (gridReady)="onGridReady($event)">
  </ag-grid-angular>
</div> -->

<!-- Formulario de Parametro Para Post -->
<app-lfsa-card *ngIf="mostrarFormulario" [innTemplate]="enviarTemplateForm"
               [titulo]="'Parametros Cobros AutoServicios'"></app-lfsa-card>

<ng-template #enviarTemplateForm>
  <form [formGroup]="formulario" class="form-group" novalidate>

    <div class="row">

      <div class="form-group col-md-6 ">
        <app-lfsa-input (input)="this.formulario.patchValue({nombreFormato: $any($event.target).value.toUpperCase()})"
                        [claseLabel]="'letrasDanger'" [control]="this.formulario.get('nombreFormato')"
                        [id]="'nombreFormato'"
                        [label]="'Nombre estructura*'" formControlName="nombreFormato"
                        type="text"></app-lfsa-input>
      </div>

      <div class="form-group col-md-6 ">
        <app-lfsa-combo-box [claseLabel]="'letrasDanger'" [comboBox]="cmbDelimitador"
                            [control]="this.formulario.get('delimitador')"
                            [idOpcion]="'id'" [id]="'delimitador'" [label]="'Delimitador*'"
                            [opcion]="'valor'"
                            formControlName="delimitador"></app-lfsa-combo-box>
      </div>

    </div>

    <div class="row">

      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('linIniDatos')"
                        [id]="'linIniDatos'" [label]="'Linea Inicial*'"
                        formControlName="linIniDatos" type="number"></app-lfsa-input>
      </div>

      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('poscValor')" [id]="'poscValor'"
                        [label]="'Posición Valor*'"
                        formControlName="poscValor" type="number"></app-lfsa-input>
      </div>

      <div class="form-group col-md-4 ">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('poscSigno')" [id]="'poscSigno'"
                        [label]="'Posición Signo*'"
                        formControlName="poscSigno" type="number"></app-lfsa-input>
      </div>

    </div>

    <div class="row">
      <div class="form-group col-md-4 ">
        <app-lfsa-combo-box (change)="changeTipoDoc($event.target)" [claseLabel]="'letrasDanger'"
                            [comboBox]="cmbTipoDocumento"
                            [control]="this.formulario.get('tipoDocumento')" [idOpcion]="'id'" [id]="'tipoDocumento'"
                            [label]="'Tipo Documento*'" [opcion]="'valor'"
                            formControlName="tipoDocumento"></app-lfsa-combo-box>
      </div>

      <div [hidden]="deshabpoNumDoc" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('poscNumDocumento')"
                        [id]="'poscNumDocumento'"
                        [label]="'Posición N°Documento*'" formControlName="poscNumDocumento"
                        type="number"></app-lfsa-input>
      </div>

      <div [hidden]="deshabpoNumRef" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [claseLabel]="'letrasDanger'" [control]="this.formulario.get('poscReferencia')"
                        [id]="'poscReferencia'"
                        [label]="'Posición N°Referencia*'" formControlName="poscReferencia"
                        type="number">
        </app-lfsa-input>
      </div>

    </div>

    <div [hidden]="true" class="row">
      <div class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-combo-box (change)="changeNumComprobante($event.target)" [comboBox]="cmbOptions"
                            [control]="this.formulario.get('numComprobamPresent')"
                            [idOpcion]="'id'" [id]="'numComprobamPresent'"
                            [label]="'N° Comprobante'"
                            [opcion]="'valor'"
                            formControlName="numComprobamPresent">
        </app-lfsa-combo-box>
      </div>
      <div [hidden]="deshabComProbante" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [control]="this.formulario.get('posColumComproban')" [id]="'posColumComproban'"
                        [label]="'Posición Columna N°Comprobante'"
                        formControlName="posColumComproban"
                        type="number"></app-lfsa-input>
      </div>
      <div [hidden]="deshabComProbante" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [control]="this.formulario.get('posFilaComproban')" [id]="'posFilaComproban'"
                        [label]="'Posición Fila N°Comprobante'"
                        formControlName="posFilaComproban"
                        type="number"></app-lfsa-input>
      </div>
    </div>

    <div [hidden]="true" class="row">
      <div class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-combo-box (change)="changeTotal($event.target)" [comboBox]="cmbOptions"
                            [control]="this.formulario.get('totalPresent')" [idOpcion]="'id'"
                            [id]="'totalPresent'" [label]="'Total'" [opcion]="'valor'"
                            formControlName="totalPresent"></app-lfsa-combo-box>
      </div>
      <div [hidden]="deshabTotal" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [control]="this.formulario.get('posColumTot')" [id]="'posColumTot'"
                        [label]="'Posición Columna Total'"
                        formControlName="posColumTot" type="number"></app-lfsa-input>
      </div>
      <div [hidden]="deshabTotal" class="form-group col-md-4 animated fadeInRight">
        <app-lfsa-input [control]="this.formulario.get('posFilaTot')" [id]="'posFilaTot'"
                        [label]="'Posición Fila Total'" formControlName="posFilaTot"
                        type="number"></app-lfsa-input>
      </div>
    </div>

  </form>
  <br>
  <div class="row">
    <div class="form-group col-12">
      <app-lfsa-botones-formulario (devolverAccion)="acciones($event)" [formularioValido]="formulario.invalid"
                                   [loading]="loading"
                                   [textBoton]="textBoton"></app-lfsa-botones-formulario>
    </div>
  </div>
</ng-template>

<!-- <div class="row animated fadeInRight" *ngIf="mostrarFormulario">

    <div class="col-sm-12">
      <div class="card">
        <div class="card-header">
          <strong>Parametros Cobros AutoServicios</strong>
        </div>

        <div class="card-body">
          <form [formGroup]="formulario" novalidate class="form-group">

            <div class="row">

              <div class="form-group col-md-6 animated fadeInRight">
                <app-lfsa-input [label]="'Nombre estructura'" type="text" [id]="'nombreFormato'"
                  formControlName="nombreFormato" [control]="this.formulario.get('nombreFormato')"
                  (input)="this.formulario.patchValue({nombreFormato: $event.target.value.toUpperCase()})"></app-lfsa-input>
              </div>

              <div class="form-group col-md-6 animated fadeInRight">
                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbDelimitador"
                  formControlName="delimitador" [label]="'Delimitador'" [id]="'delimitador'"
                  [control]="this.formulario.get('delimitador')"></app-lfsa-combo-box>
              </div>

            </div>

            <div class="row">

              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-input [label]="'Linea Inicial'" type="number" [id]="'linIniDatos'"
                  formControlName="linIniDatos" [control]="this.formulario.get('linIniDatos')"></app-lfsa-input>
              </div>

              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-input [label]="'Posición Valor'" type="number" [id]="'poscValor'"
                  formControlName="poscValor" [control]="this.formulario.get('poscValor')"></app-lfsa-input>
              </div>

              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-input [label]="'Posición Signo'" type="number" [id]="'poscSigno'"
                  formControlName="poscSigno" [control]="this.formulario.get('poscSigno')"></app-lfsa-input>
              </div>

            </div>

            <div class="row">
              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbTipoDocumento"
                  formControlName="tipoDocumento" [label]="'Tipo Documento'" [id]="'tipoDocumento'"
                  [control]="this.formulario.get('tipoDocumento')" (change)="changeTipoDoc($event.target)"></app-lfsa-combo-box>
              </div>

              <div class="form-group col-md-4 animated fadeInRight" [hidden]="deshabpoNumDoc">
                <app-lfsa-input [label]="'Posición N°Documento'" type="number" [id]="'poscNumDocumento'"
                  formControlName="poscNumDocumento" [control]="this.formulario.get('poscNumDocumento')"></app-lfsa-input>
              </div>

              <div class="form-group col-md-4 animated fadeInRight" [hidden]="deshabpoNumRef">
                <app-lfsa-input [label]="'Posición N°Referencia'" type="number" [id]="'poscReferencia'"
                  formControlName="poscReferencia" [control]="this.formulario.get('poscReferencia')"></app-lfsa-input>
              </div>

            </div>

            <div class="row" [hidden]="true">
              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbOptions"
                  formControlName="numComprobamPresent" [label]="'N° Comprobante'" [id]="'numComprobamPresent'"
                  [control]="this.formulario.get('numComprobamPresent')" (change)="changeNumComprobante($event.target)"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4 animated fadeInRight" [hidden]="deshabComProbante">
                <app-lfsa-input [label]="'Posición Columna N°Comprobante'" type="number" [id]="'posColumComproban'"
                  formControlName="posColumComproban" [control]="this.formulario.get('posColumComproban')"></app-lfsa-input>
              </div>
              <div class="form-group col-md-4 animated fadeInRight"  [hidden]="deshabComProbante">
                <app-lfsa-input [label]="'Posición Fila N°Comprobante'" type="number" [id]="'posFilaComproban'"
                  formControlName="posFilaComproban" [control]="this.formulario.get('posFilaComproban')"></app-lfsa-input>
              </div>
            </div>

            <div class="row" [hidden]="true">
              <div class="form-group col-md-4 animated fadeInRight">
                <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'id'" [comboBox]="cmbOptions"
                  formControlName="totalPresent" [label]="'Total'" [id]="'totalPresent'"
                  [control]="this.formulario.get('totalPresent')" (change)="changeTotal($event.target)"></app-lfsa-combo-box>
              </div>
              <div class="form-group col-md-4 animated fadeInRight" [hidden]="deshabTotal">
                <app-lfsa-input [label]="'Posición Columna Total'" type="number" [id]="'posColumTot'"
                  formControlName="posColumTot" [control]="this.formulario.get('posColumTot')"></app-lfsa-input>
              </div>
              <div class="form-group col-md-4 animated fadeInRight" [hidden]="deshabTotal">
                <app-lfsa-input [label]="'Posición Fila Total'" type="number" [id]="'posFilaTot'"
                  formControlName="posFilaTot" [control]="this.formulario.get('posFilaTot')"></app-lfsa-input>
              </div>
            </div>

          </form>
          <br>
          <div class="row">
            <div class="form-group col-12">
              <app-lfsa-botones-formulario [formularioValido]="formulario.invalid" (devolverAccion)="acciones($event)"
                [textBoton]="textBoton"></app-lfsa-botones-formulario>
            </div>
          </div>
        </div>
      </div>
    </div>

</div> -->
